import MggpPlayer from 'mggp-player';

const INTRO = "intro";
const RECAP = "recap";
const PROPERTY_CAN_SKIP = "sip:canSkip";
const PROPERTY_SKIPPED = "sip:skipped";
const MIN_SKIP_TIME = 500;

const MCH_ALLOWED = window.location.href.indexOf("sip_m_ch_allowed") > 0; //Todo: Testing MHP-2143

export default class MggpPluginSkipIntro extends MggpPlayer.Plugin {
  constructor(...params) {
    super(...params);

    this.namespase = "sip"; //Skip Intro Plugin
    this.timeMarkers = null;
    this.playerState = -1;
    this.playerPosition = 0;
    this.skipInProgress = false;
    this.skipStarted = false;
    this.minSkipTimeArrived = false;

    this.onSkip = this.onSkip.bind(this);
    this.onPlayerStateChange = this.onPlayerStateChange.bind(this);
    this.onPlayerPositionChange = this.onPlayerPositionChange.bind(this);
    this.onVideoInfo = this.onVideoInfo.bind(this);
    this.onAdShowing = this.onAdShowing.bind(this);

    //IE fix
    if (!this.config && !this.player) {
      this.player = arguments[0];
      this.config = arguments[1];
    }

    this.init();
  }

  init() {
    this.player.registerProperty(PROPERTY_CAN_SKIP, false, false);

    this.player.on("property:videoInfo", this.onVideoInfo);
  }

  toggleEvents(pOn) {
    if(pOn) {
      this.player.on("property:state", this.onPlayerStateChange);
      this.player.on("property:position", this.onPlayerPositionChange);
      this.player.on("sip:skip", this.onSkip);
      this.player.on('property:ad:showing', this.onAdShowing);
    } else {
      this.player.off("property:state", this.onPlayerStateChange);
      this.player.off("property:position", this.onPlayerPositionChange);
      this.player.off("sip:skip", this.onSkip);
      this.player.off('property:ad:showing', this.onAdShowing);
    }
  }

  //Disable skip if ad started
  onAdShowing(e) {
    if(e.data && this.skipStarted) this.fireSkipEnded();
  }

  onVideoInfo(e) {
    this.player.set(PROPERTY_CAN_SKIP, false);
    this.player.emit(PROPERTY_SKIPPED);

    this.timeMarkers = e.data?.time_markers ?? null;
    this.playerState = -1;
    this.playerPosition = 0;
    this.skipStarted = false;
    this.skipInProgress = false;

    //Disable skip intro from m channel
    if(e.data && e.data.content_type?.indexOf('m_ch') >= 0 && !MCH_ALLOWED) this.timeMarkers = null;

    this.toggleEvents(this.timeMarkers);
  }

  onPlayerStateChange(e) {
    this.playerState = e.data;
    switch (this.playerState) {
      case 4: //seek
        if(this.skipInProgress) this.skipStarted = true;
        break;
      case 1:
      case 2:
      case 5:
        if(this.skipStarted && this.minSkipTimeArrived) {
          this.fireSkipEnded();
        }
    }
  }

  onPlayerPositionChange(e) {
    this.playerPosition = e.data;

    if (!this.timeMarkers || this.skipInProgress) return;

    if (this.inRange(INTRO, this.playerPosition)) {
      this.player.set(PROPERTY_CAN_SKIP, true);
    } else if (this.inRange(RECAP, this.playerPosition)) {
      this.player.set(PROPERTY_CAN_SKIP, true);
    } else if(this.player.get(PROPERTY_CAN_SKIP)) {
      this.player.set(PROPERTY_CAN_SKIP, false);
    }
  }

  onSkip() {
    if(!this.timeMarkers) return;
    const isIntro = this.inRange(INTRO, this.playerPosition);
    const isRecap = this.inRange(RECAP, this.playerPosition);

    if(isIntro || isRecap) {
      this.fadeOutVolume();
      this.player.set(PROPERTY_CAN_SKIP, false);

      setTimeout(()=> {
        this.onSkipTime();
        this.restoreVolume();
        this.player.seekTo(isIntro ? this.timeMarkers.intro_stop : this.timeMarkers.recap_stop);
      }, this.player.config.skipTimeDelay || MIN_SKIP_TIME);

      this.skipInProgress = true;
    }
  }

  onSkipTime() {
     this.minSkipTimeArrived = true;
     this.onPlayerStateChange({data: this.player.get("state")})
  }

  inRange(pType, pPosition) {
    if(!this.timeMarkers) return;

    if(pType === INTRO) return pPosition < this.timeMarkers.intro_stop && pPosition > this.timeMarkers.intro_start;
    if(pType === RECAP) return pPosition < this.timeMarkers.recap_stop && pPosition > this.timeMarkers.recap_start;
  }

  fireSkipEnded() {
    this.player.emit(PROPERTY_SKIPPED);
    this.skipStarted = false;
    this.skipInProgress = false;
    this.minSkipTimeArrived = true;
  }

  fadeOutVolume() {
    const video = this.player.getPlayableElement();
    if(!video) return;

    this.originalVolume = video.volume || 0;
    let volume = this.originalVolume;
    const fadeOutInterval = setInterval(() => {
      if (volume > 0.1) {
        volume -= 0.1;
        video.volume = volume;
      } else {
        video.volume = 0;
        clearInterval(fadeOutInterval);
      }
    }, 50);
  }

  restoreVolume() {
    const video = this.player.getPlayableElement();
    if(!video) return;

    let volume = video.volume || 0;
    const fadeInInterval = setInterval(() => {
      if (volume < this.originalVolume - 0.1) {
        volume += 0.1;
        video.volume = volume;
      } else {
        video.volume = this.originalVolume;
        clearInterval(fadeInInterval);
      }
    }, 50);
  }
}
